<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Cập nhật món ăn</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <DishForm ref="dishForm" :dishData="dishData" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DishForm from '@/modules/dish/DishForm.vue'
import { mapActions } from 'vuex'
import { get } from 'lodash'

export default {
  components: {
    DishForm
  },
  props: {
    state: Boolean,
    dishData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      description: ''
    }
  },
  computed: {},
  methods: {
    ...mapActions('Dishes', ['updateDish', 'uploadImage', 'destroyImage']),
    cancel() {
      this.dialog = false
      this.$refs.dishForm.resetDefault()
      this.$refs.dishForm.resetValidation()
    },
    async save() {
      if (!this.$refs.dishForm.validate()) return
      this.$loading.active = true
      try {
        const data = this.$refs.dishForm.getData()
        if (data.rawImageRemoved && !data.image) {
          // delete image on db
          await this.destroyImage(this.dishData.image.id)
        }
        if (data.image) {
          if (get(this.dishData, 'image.url')) await this.destroyImage(this.dishData.image.id)

          let formData = new FormData()
          formData.append('files', data.image)
          formData.append('refId', this.dishData.id)
          formData.append('ref', 'dish')
          formData.append('field', 'image')
          await this.uploadImage(formData)
        }

        await this.updateDish({
          id: this.dishData.id,
          name: data.name,
          type: data.type
        })

        this.dialog = false
        this.$alert.updateSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
